import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuHeader } from 'src/models/others/MenuHeader';

@Injectable({
  providedIn: 'root'
})
export class DatatransferService {

  constructor() { }


  private ntfFlag: boolean;
  setNtfFlag(flg: boolean) {
    this.ntfFlag = flg;
  }
  getNtfFlag() {
    return this.ntfFlag;
  }

  private empId: any;
  setEmpId(id: any) {
    this.empId = id;
  }
  getEmpId() {
    return this.empId;
  }
  private empName: string;
  setEmpName(name: string) {
    this.empName = name;
  }
  getEmpName() {
    return this.empName;
  }
  private menuId: number;
  setMenuId(id: number) {
    this.menuId = id;
  }
  getMenuId() {
    return this.menuId;
  }
  private menuName: string;
  setMenuName(name: string) {
    this.menuName = name;
  }
  getMenuName() {
    return this.menuName;
  }
  private menuList: MenuHeader[];
  setMenuList(list: MenuHeader[]) {
    this.menuList = list;
  }
  getMenuList() {
    return this.menuList;
  }
}
